import { render, staticRenderFns } from "./worldMap.vue?vue&type=template&id=2e1d7b3a&scoped=true&"
import script from "./worldMap.vue?vue&type=script&lang=js&"
export * from "./worldMap.vue?vue&type=script&lang=js&"
import style0 from "./worldMap.vue?vue&type=style&index=0&id=2e1d7b3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d7b3a",
  null
  
)

export default component.exports